import Recaptcha from './src/JsmRecaptcha.vue'

Recaptcha.install = (Vue) => {
  Vue.component(Recaptcha.name, Recaptcha)
}

export default Recaptcha
